export default "__VITE_ASSET__cfb558a3__"